import { updateBreadcrumbTitle } from './react_app/components/BreadcrumbBar/BreadcrumbBarActions';

const actions = { updateBreadcrumbTitle };
export default actions;
